import React, { ChangeEvent } from 'react';
import styled from 'styled-components';

interface SliderProps {
  min: number;
  max: number;
  step: number;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  className?: string;
}

const SliderWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const StyledSliderInput = styled.input`
  flex-grow: 1;
  margin-right: 1rem; /* Space for value display if added */
  cursor: pointer;

  /* Basic styling - can be extensively customized */
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 8px;
  background: #ddd;
  outline: none;
  opacity: 0.7;
  transition: opacity .2s;

  &:hover {
    opacity: 1;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 18px;
    height: 18px;
    background: #4CAF50; /* Green thumb */
    cursor: pointer;
    border-radius: 50%;
  }

  &::-moz-range-thumb {
    width: 18px;
    height: 18px;
    background: #4CAF50;
    cursor: pointer;
    border-radius: 50%;
    border: none; /* Important for Firefox */
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    &::-webkit-slider-thumb {
        background: #aaa;
    }
    &::-moz-range-thumb {
        background: #aaa;
    }
  }
`;

// Optional: If you want to display the current value next to the slider
const ValueDisplay = styled.span`
  font-size: 0.875rem;
  color: #333;
  min-width: 30px; // Ensure some space for the number
  text-align: right;
`;

export const Slider: React.FC<SliderProps> = ({
  min,
  max,
  step,
  value,
  onChange,
  disabled = false,
  className
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(parseFloat(event.target.value));
  };

  return (
    <SliderWrapper className={className}>
      <StyledSliderInput
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={handleChange}
        disabled={disabled}
      />
      {/* <ValueDisplay>{value.toFixed(step.toString().includes('.') ? step.toString().split('.')[1].length : 0)}</ValueDisplay> */}
    </SliderWrapper>
  );
};

export default Slider; 